import { Representante } from '../representante';

export class RepresentantePopula {
    selected: boolean;
    exists: boolean;
    representante: Representante;

    constructor(representante: Representante) {
        this.representante = representante;
    }
}
